import { render } from "./TemporaryLanding.vue?vue&type=template&id=64dc0754&scoped=true"
import script from "./TemporaryLanding.vue?vue&type=script&lang=js"
export * from "./TemporaryLanding.vue?vue&type=script&lang=js"

import "./TemporaryLanding.vue?vue&type=style&index=0&id=64dc0754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dc0754"]])

export default __exports__